module.exports = __webpack_public_path__ + "img/logo-white.da24aac1.svg";